// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"IdColumn_checkboxWrapper__zTyKY","errorModal":"IdColumn_errorModal__tAjxf"};